import { useEffect, useState } from "react";
import Modal from "components/Modal";
import ChartTitlesModal from "components/admin/ChartTitlesModal";
import { getTemplates } from "api/admin/index";
import { notifyError, notifyInfo, notifySuccess } from "utils/customToasts";
import loadingGif from "images/loader2.webp";

const ViewTemplatesModal = ({ open, onClose }) => {
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [chartTitlesViewOpen, setChartTitlesViewOpen] = useState(false);

    useEffect(() => {
        if (open) {
            setLoading(true);
            setTemplates([]);
            setSelectedTemplate(null);
            setChartTitlesViewOpen(false);
            getTemplates()
                .then((response) => {
                    if (response?.statusCode === "10000" && Array.isArray(response?.data)) {
                        setTemplates(response.data);
                    } else {
                        notifyError(response?.message || "Failed to load templates");
                    }
                })
                .catch(() => {
                    notifyError("Failed to load templates");
                })
                .finally(() => setLoading(false));
        }
    }, [open]);

    const handleViewChart = (template) => {
        setSelectedTemplate(template);
        setChartTitlesViewOpen(true);
    };

    const handleBackToTemplates = () => {
        setChartTitlesViewOpen(false);
        setSelectedTemplate(null);
    };

    const handleClose = () => {
        setChartTitlesViewOpen(false);
        setSelectedTemplate(null);
        onClose();
    };

    return (
        <>
            <div className="relative z-[100]">
                <Modal
                    open={open}
                    className="relative w-[40rem] px-8 py-10 bg-primary-3 text-white rounded-lg text-left"
                >
                    <div className="flex justify-between items-center">
                    <h1 className="text-center text-2xl">Templates</h1>
                    {/* toast message we need to show when user clicks on create template */}
                    <button type="button" onClick={() => notifyInfo("Coming soon! This feature is not available yet.")}  className="py-1.5 px-3 text-sm rounded bg-primary-1 text-white hover:bg-primary-1/80 shrink-0"
                    >
                        Create Template
                    </button>
                    </div>
                    <div className="mt-6 flex flex-col gap-3">
                        {loading ? (
                            <div className="flex items-center justify-center py-8 gap-2 text-gray-400">
                                <img src={loadingGif} alt="Loading" className="h-5 w-5" />
                                <span>Loading templates…</span>
                            </div>
                        ) : templates.length === 0 ? (
                            <p className="text-gray-400 py-4">No templates available.</p>
                        ) : (
                            <div className="space-y-2 max-h-80 overflow-y-auto">
                                {templates.map((template) => (
                                    <div
                                        key={template._id}
                                        className="flex items-center justify-between gap-4 px-4 py-3 rounded-lg border border-primary-light bg-primary-3"
                                    >
                                        <span className="text-white font-medium truncate flex-1">
                                            {template.name ?? "Unnamed template"}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={() => handleViewChart(template)}
                                            className="py-1.5 px-3 text-sm rounded bg-primary-1 text-white hover:bg-primary-1/80 shrink-0"
                                        >
                                            View chart
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div className="flex justify-end mt-6">
                        <button
                            type="button"
                            className="py-2 px-4 border border-gray-200 rounded text-gray-300"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </div>
                </Modal>
            </div>

            <ChartTitlesModal
                open={chartTitlesViewOpen}
                onClose={handleBackToTemplates}
                template={selectedTemplate}
            />
        </>
    );
};

export default ViewTemplatesModal;
